import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { HelpCenterManagementMenuLinkItem } from './HelpCenterManagementMenuLinkItem.tsx';

export const HelpCenterManagement = (props: Nav4DragAndDropMenuItemProps): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-help-center-management">
		<JSErrorBoundary
			fallback="flag"
			id="helpCenterManagement"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentHelpCenterManagement"
			teamName="jsm-megatron"
		>
			<HelpCenterManagementMenuLinkItem {...props} />
		</JSErrorBoundary>
	</UFOSegment>
);
